import { ChevronLeft } from 'lucide-react';
import { IconButton } from './IconButton';
import { useTranslation } from '../../../lib/i18n';
import styles from './BackButton.module.css';

// THE mobile back affordance — a 40px floating circular puck holding a chevron IconButton. It is the
// leading control on every drill-in screen on narrow (BrandHeader's `showBack` slot); sharing it here
// means a modal/sheet that carries its own way out (the Agent skills sheet) draws the EXACT same
// button rather than a look-alike. `className` is for layout only (positioning / self-alignment at
// the call site) — the puck's skin is fixed.
export function BackButton({ onClick, className }: { onClick: () => void; className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={className ? `${styles.puck} ${className}` : styles.puck}>
      <IconButton
        aria-label={t('common.back')}
        title={t('common.back')}
        size="medium"
        variant="text"
        onClick={onClick}
        className={styles.button}
      >
        <ChevronLeft size={20} aria-hidden className="dir-flip" />
      </IconButton>
    </span>
  );
}
